import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-virtualsports',
  templateUrl: './virtualsports.component.html',
  styleUrls: ['./virtualsports.component.scss'],
})
export class VirtualsportsComponent implements OnInit {
  title = 'app-virtualsports';

  ngOnInit(): void {}
}
